import { render, staticRenderFns } from "./Conpany.vue?vue&type=template&id=3fadaa3a&scoped=true"
import script from "./Conpany.vue?vue&type=script&lang=js"
export * from "./Conpany.vue?vue&type=script&lang=js"
import style0 from "./Conpany.vue?vue&type=style&index=0&id=3fadaa3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fadaa3a",
  null
  
)

export default component.exports